import {useState} from 'react';

import KeyIcon from '@mui/icons-material/Key';
import {Alert, Box, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import muiStyled from '@mui/material/styles/styled';
import {bool, func} from 'prop-types';

import {sourceShape} from '../../../../proptypes-shapes';
import Button from '../../../form/buttons/Button/Button';
import SingleSourceStatusChip from '../SingleSourceStatusChip/SingleSourceStatusChip';
import UpdateSourceModal from '../UpdateSourceModal/UpdateSourceModal';

const SourceName = muiStyled(Typography)(() => ({
  fontSize: 15,
  fontWeight: 'bold'
}));

const ConnectionDetails = muiStyled(Typography)(() => ({
  fontSize: 14,
  color: 'grey'
}));

const ConnectionType = muiStyled(Typography)(() => ({
  fontSize: 13,
  color: 'grey'
}));

const SingleSourceContainer = muiStyled(Box)(({theme}) => ({
  borderRadius: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  border: '1px solid #dedede',
  overflow: 'hidden'
}));

const SingleSource = ({source, isTestingConnection, testConnection}) => {
  const [isUpdateSourceModalOpen, setIsUpdateSourceModalOpen] = useState(false);
  const isConnected = source.is_connected.code === 200;

  return (
    <SingleSourceContainer key={source.id}>
      <Grid
        container
        gap={2}
        alignItems="center"
        p={{
          xs: 1,
          sm: 2
        }}
      >
        <Grid item xs="auto" md="auto">
          <Box component="img" src={source.logo} sx={{maxWidth: 50}} />
        </Grid>
        <Grid
          item
          flex={{
            xs: 0,
            md: 1
          }}
          xs="auto"
          md
        >
          <SourceName>{source.connector_name}</SourceName>
          <ConnectionDetails>{source.connection_details}</ConnectionDetails>
          <Grid container gap={1} mt={1} alignItems="center">
            <SingleSourceStatusChip isConnected={isConnected} errorMessage={source.is_connected.message} isTestingConnection={isTestingConnection} onTest={testConnection} />
            <ConnectionType>Type: {source.datasourceType}</ConnectionType>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md="auto"
          display={{
            xs: 'flex'
          }}
          justifyContent={{
            xs: 'flex-end'
          }}
        >
          <Button
            startIcon={<KeyIcon />}
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => {
              setIsUpdateSourceModalOpen(true);
            }}
          >
            Mettre à jour
          </Button>
        </Grid>
      </Grid>

      <UpdateSourceModal
        source={source}
        isOpen={isUpdateSourceModalOpen}
        onClose={() => {
          setIsUpdateSourceModalOpen(false);
        }}
      />
      {source.message && !isConnected && <Alert severity="warning">{source.message}</Alert>}
    </SingleSourceContainer>
  );
};

SingleSource.propTypes = {
  isTestingConnection: bool.isRequired,
  testConnection: func.isRequired,
  source: sourceShape.isRequired
};

export default SingleSource;
